<template>
  <div class="c-textarea">
    <div class="c-title-warp">
      <div class="c-col-field" v-if="!smart">{{ description }}</div>
      <div class="c-caption">
        <textarea
          ref="title"
          class="c-caption-input"
          v-model="textarea"
          :placeholder="`请输入${description}（${min}~${max}个字符,两个英文占一个字符）`"
        ></textarea>
        <span class="c-caption-num">
          <ins :class="warnClass">{{ len }}</ins
          >/{{ max }}
        </span>
      </div>
      <div v-show="false" class="add-document" :class="{ 'c-smart-document': smart }">
        <Button type="primary" @click="$emit('on-select', { name, min, max })">选择文案</Button>
      </div>
    </div>
    <div class="c-words" :class="{ 'c-smart-words': smart }" v-if="words.length > 0">
      <span>动态词插入：</span>
      <a v-for="(item, key) in words" :key="key" class="c-item-word" @click="setWord(item)">{{ item.name }}</a>
    </div>
    <div v-if="msg" class="c-col-msg" :class="{ 'c-smart-msg': smart }">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import { getByteLen, isEmpty, isArray } from '@/common/js/utils'
import mixinVerify from './mixin-verify'
export default {
  name: 'CTitle',
  mixins: [mixinVerify],
  props: {
    value: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    words: {
      type: Array
    },
    description: {
      type: String,
      default: ''
    },
    smart: {
      type: Boolean,
      default: false
    },
    min: {
      type: [Number, String],
      default: 1
    },
    max: {
      type: [Number, String],
      default: 20
    },
    required: {
      type: Boolean,
      default: false
    },
    verify: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    textarea: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    len() {
      let num = 0
      const title = this.textarea
      if (!isEmpty(title)) {
        const textarea = this.delWord(title)
        const words = this.getWords(title)
        num += getByteLen(textarea)
        if (isArray(words)) num += words.map((ret) => ret.max_word_length).reduce((total, n) => total + n, 0)
      }
      return num
    },
    warnClass() {
      return this.len > this.max ? 'm-num-warn' : ''
    }
  },
  methods: {
    delWord(title) {
      return title.replace(/\[[\u4e00-\u9fa5]{2,}\]/g, '')
    },
    getWords(title) {
      if (typeof title !== 'string' || isEmpty(title)) return
      // 正则匹配
      const matchWords = title.match(/\[[\u4e00-\u9fa5]{2,}\]/g)
      const keys = this.words.map((ret) => ret.name)
      if (!isArray(matchWords)) return
      return matchWords.map((key) => {
        try {
          return this.getWordKey(key, keys)
        } catch (err) {
          console.log(err)
        }
      })
    },
    getWordKey(key, keys) {
      if (key && isArray(keys)) {
        const len = typeof key === 'string' ? key.length : 0
        key = key.replace(/\[|\]/g, '')
        if (keys.includes(key)) {
          return this.words[this.words.findIndex((ret) => ret.name === key)]
        } else {
          return { name: key, max_word_length: len }
        }
      } else {
        throw new Error('查找动态词位置错误')
      }
    },
    setWord(word) {
      const cut = this.$refs.title.selectionStart
      const { name } = word
      if (typeof cut === 'number') {
        const title = this.textarea
        const prefix = title.substring(0, cut)
        const suffix = title.substring(cut)
        const newTitle = `${prefix}[${name}]${suffix}`
        this.$emit('input', newTitle)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.c-textarea {
  position: relative;

  .c-title-warp {
    display: flex;
  }

  .c-col-field {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 120px;
    line-height: 32px;
    text-align: right;
    padding-right: 12px;
  }

  .c-caption {
    width: 320px;
    padding: 5px;
    text-align: right;
    border: solid 1px #dcdee2;

    .c-caption-input {
      width: 100%;
      display: block;
      background-color: #fff;
      background-image: none;
      border: 0;
      overflow: hidden;
      resize: none;
      outline: 0;
    }

    .c-caption-num {
      color: #666;
      font-size: 85%;

      .m-num-warn {
        color: #ff4400;
      }
    }
  }

  .add-document {
    position: absolute;
    top: 0;
    left: 444px;

    &.c-smart-document {
      left: 324px;
    }
  }

  .c-words {
    padding: 4px 0 4px 120px;

    &.c-smart-words {
      padding-left: 0;
    }

    .c-item-word,
    .c-del-a {
      user-select: none;
    }

    .c-item-word {
      line-height: 25px;
      padding: 0 5px;
      white-space: nowrap;
    }

    .c-del-word {
      display: inline-block;
      margin-left: 20px;

      .c-del-a {
        color: #ff4400;
      }
    }

    .ivu-poptip {
      vertical-align: middle;
      margin-top: -3px;
    }
  }

  .c-col-msg {
    position: absolute;
    z-index: 4;
    left: 120px;
    bottom: -4px;
    color: #ff4400;

    &.c-smart-msg {
      left: 0;
    }
  }
}
</style>
